export const BUDGET_FIELDS = ['currency', 'premium', 'developmentPeriod'];
